import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  InputGroup,
  ProgressBar,
  Row,
  Spinner,
} from "react-bootstrap";
import CustomRadioButton from "../../../../../../components/CustomRadioButton";
import Flatpickr from "react-flatpickr";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getCalendarSvg } from "../../../../../../svgIcons/CalenderIcons";
import Select, { components } from "react-select";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { formatDate } from "../../../../../../helpers/dateFormatter";
import { toast } from "react-toastify";
import { usePostPriceScheduleExclusiveMutation } from "../../../../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../../../../assets/delete-item-icon.svg";
import { v4 as uuidv4 } from "uuid"; // Import UUID
import { generateTimeOptions } from "../../../../../../helpers/timeFormatter";

// Example time options
const timeOptions = generateTimeOptions();

const numberOptions = Array.from({ length: 99 }, (_, i) => ({
  value: i + 1,
  label: i + 1,
}));

const validationSchema = Yup.object().shape({
  startDate: Yup.date().required("Start date is required"),
  daysApply: Yup.array()
    .min(1, "Please select at least one day")
    .required("Please select at least one day"),
});

const PSstepThree = ({
  setStep,
  setData,
  handleClose,
  weeklyData,
  ageGroupData,
  productDetail,
  productId,
  setStepOneData,
  stepOneData,
  productOptionId,
}) => {
  const navigate = useNavigate();
  const [postPriceScheduleExclusive, { isLoading }] =
    usePostPriceScheduleExclusiveMutation();
  const flatpickrRef = useRef();
  const flatpickrRef2 = useRef();
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedDays, setSelectedDays] = useState(false);
  const [liveAvailability, setLiveAvailability] = useState(true);

  // Values for days field
  const handleDayClick = (dayId, values, setFieldValue) => {
    const updatedDays = values?.daysApply?.includes(dayId)
      ? values.daysApply.filter((id) => id !== dayId)
      : [...values.daysApply, dayId];
    setFieldValue("daysApply", updatedDays);
    if (values?.daysApply?.includes(dayId)) {
      setSelectedDays(false);
    }
    if (updatedDays.length === 7) {
      setSelectedDays(true);
    }
  };

  const handleSelectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    setFieldValue("daysApply", allDayIds);
  };

  const handleDeselectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    if (allDayIds.every((dayId) => values.daysApply.includes(dayId))) {
      setFieldValue("daysApply", []);
    }
  };

  // Time slot selection
  const [timeSlots, setTimeSlots] = useState([
    { id: uuidv4(), start_time: "", end_time: "" },
  ]);
  const [timeError, setTimeError] = useState("");

  const handleStartTimeChange = (id, selectedOption) => {
    const newTimeSlots = timeSlots.map((slot) =>
      slot.id === id ? { ...slot, start_time: selectedOption.value } : slot
    );
    setTimeSlots(newTimeSlots);
  };

  // Handle removing a time slot by id
  const handleRemoveTimeSlot = (idToRemove) => {
    const updatedTimeSlots = timeSlots.filter((slot) => slot.id !== idToRemove);
    setTimeSlots(updatedTimeSlots); // Update state after removal
  };

  const handleEndTimeChange = (index, selectedOption) => {
    setTimeError(""); // Clear any existing error
    const newTimeSlots = [...timeSlots]; // Create a copy of the existing time slots

    // Update the end_time for the current index
    newTimeSlots[index].end_time = selectedOption.value;
    setTimeSlots(newTimeSlots); // Update the state with the modified time slots

    // Check if the next index already has a time slot
    if (!newTimeSlots[index + 1]) {
      addTimeSlot(); // Add a new time slot if the next index doesn't exist
    }
  };

  const addTimeSlot = () => {
    setTimeSlots([
      ...timeSlots,
      { id: uuidv4(), start_time: "", end_time: "" },
    ]);
  };

  const validateTimeSlots = () => {
    let valid = true;
    setTimeError(""); // Clear previous errors

    // for (const [index, slot] of timeSlots.entries()) {
    //   if (slot.start_time && !slot.end_time) {
    //     setTimeError(
    //       `Start time ${slot.start_time} at slot ${
    //         index + 1
    //       } does not have a corresponding end time.`
    //     );
    //     return false; // Exit early since validation failed
    //   }
    // }

    return valid;
  };

  const getEndTimeOptions = (startTime) => {
    return timeOptions.filter((option) => option.value > startTime);
  };

  // Max pax table
  const [rows, setRows] = useState([
    { maxPax: "", retailPrice: "", commission: "", yourShare: "", error: "" },
  ]);
  const [formError, setFormError] = useState("");

  const handleAddRow = () => {
    setRows([
      ...rows,
      { maxPax: "", retailPrice: "", commission: "", yourShare: "", error: "" },
    ]);
  };

  const handleChange = (index, field, value) => {
    setFormError("");
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Clear any existing errors when fields are modified
    if (field === "maxPax" || field === "retailPrice") {
      updatedRows[index].error = "";
    }

    setRows(updatedRows);
  };

  const validateMaxPax = () => {
    let hasValidRow = false;
    let validRow = true;
    setFormError(""); // Reset the form error before validation
    rows?.forEach((row) => {
      if (row.maxPax && !row.retailPrice) {
        validRow = false;
      }

      if (row.maxPax && row.retailPrice) {
        hasValidRow = true; // At least one valid row exists
      }
    });
    if (!validRow) {
      setFormError("Retail price is required if max pax is entered");
    }

    if (!hasValidRow) {
      setFormError("Please add max pax value.");
    }
    if (!validRow || !hasValidRow) {
      return false;
    } else {
      return true;
    }
    // return true; // Validation passed
  };

  const convertArrayToPriceCategories = (array) => {
    return array
      .filter((item) => item.maxPax) // Filter out empty objects
      .map((item) => ({
        price_age_category_id: 4,
        retail_price: parseFloat(item.retailPrice) || 0, // Convert retailPrice to a number
        max_quantity: parseInt(item.maxPax, 10) || 0, // Convert maxPax to a number
      }));
  };

  return (
    <Formik
      initialValues={{
        startDate: null,
        endDate: null,
        daysApply: [],
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        try {
          const validPax = validateMaxPax();
          const validDay = validateTimeSlots();
          if (validPax) {
            let data = {
              product_id: productId,
              option_title: stepOneData.optionName,
              product_price_unit: stepOneData.priceType,
              max_capacity_per_booking: parseInt(stepOneData.number.value),
              start_date: formatDate(values.startDate),
              end_date: values.endDate ? formatDate(values.endDate) : null,
              schedules_days: values.daysApply,
              time_type: "FixedSlots",
              price_age_categories: convertArrayToPriceCategories(rows),
              start_time: timeSlots
                .map((slot) => slot.start_time)
                .filter((time) => time !== ""),
              live_availability: liveAvailability ? 1 : 0,
              // end_time: timeSlots
              //   .map((slot) => slot.end_time)
              //   .filter((time) => time !== ""),
            };
            if (productOptionId) {
              data = { ...data, product_option_id: productOptionId };
            }
            const response = await postPriceScheduleExclusive(data);

            if (response?.data?.status) {
              toast.success(response?.data?.message, {
                position: "top-center",
                autoClose: 3000,
              });
              handleClose();
              setStep(1);
              // setStepOneData(null);
            }
            if (response?.error) {
              const errors = response?.error?.data?.errors;
              if (response?.error?.status === 401) {
                localStorage.removeItem("DODLoginToken");
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
                navigate("/login");
              } else if (errors) {
                for (const field in errors) {
                  if (errors.hasOwnProperty(field)) {
                    // const combinedErrors = errors[field].join(" ");
                    // if (field === "supplier_type") {
                    //   setFieldError("option", combinedErrors);
                    // }
                  }
                }
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              } else {
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              }
            }
          }
        } catch (error) {}
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <>
          <div className="cs-ps-modal-header">
            <div className="row">
              <div className="col-md-9">
                <p className="cp-ps-form-heading">Schedule and prices</p>
                <p className="cp-ps-note">
                  Here are the detail of price option, this can be managed later
                  anytime from product management
                </p>
                <div className="d-flex cp-ps-private-header">
                  <p className="cp-ps-form-heading">
                    Private Land Cruiser Safari
                  </p>
                  <div className="cp-ps-private-header-span">By Vehicle</div>
                </div>
              </div>

              <div className="col-md-3 cp-ps-modal-progress-container">
                <div className="d-flex w-max align-items-center justify-content-end cp-ps-modal-progress-main">
                  <ProgressBar
                    now={100}
                    className={"cp-ps-header-progress-bar"}
                  />
                  <p className="cp-ps-header-progress-bar-text p-0 m-0">
                    2-2 Steps
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <Form onSubmit={handleSubmit}>
                <Row className="cp-ps-date-select-section mb-3">
                  <Col md={6}>
                    <Form.Group controlId="startDate">
                      <Form.Label className="cp-ps-form-label">
                        Start date
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="startDate"
                          placeholder="Set Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            maxDate: values.endDate,
                            minDate: new Date(),
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date()
                          }}
                          ref={flatpickrRef}
                          value={selectedDateFilter}
                          onChange={([date]) => {
                            setFieldValue(
                              "startDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                        <ErrorMessage
                          name="startDate"
                          component="div"
                          className="text-danger"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="endDate">
                      <Form.Label className="cp-ps-form-label">
                        End date <span>(optional)</span>
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="endDate"
                          placeholder="End Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            minDate: values.startDate,
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date()
                          }}
                          ref={flatpickrRef2}
                          value={selectedDateFilter}
                          onChange={([date]) => {
                            setFieldValue(
                              "endDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef2.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="cp-ps-step-2-tiered-pricing-table cp-ps-step-2-tiered-pricing-table-two">
                  <Row className="cp-ps-step-2-table-header cp-ps-step-2-table-header-two mx-0">
                    <Col md={3} className="ps-0">
                      Max pax
                    </Col>
                    <Col md={3} className="ps-0">
                      Retail price
                    </Col>
                    <Col md={3} className="ps-0">
                      Commission
                    </Col>
                    <Col md={3} className="ps-0">
                      Your share
                    </Col>
                  </Row>

                  {rows.map((row, index) => (
                    <Row
                      key={index}
                      className="cp-ps-step-2-table-row cp-ps-step-2-table-row-two"
                    >
                      <Col
                        md={3}
                        className="d-flex align-items-center ps-0 max-pax-input-group"
                      >
                        <Select
                          name="maxPax"
                          options={numberOptions}
                          placeholder="0"
                          className="p-0 "
                          value={numberOptions.find(
                            (option) => option.value === row.maxPax
                          )}
                          onChange={(selectedOption) => {
                            handleChange(index, "maxPax", selectedOption.value);
                          }}
                        />
                      </Col>
                      <Col md={3} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Retail price"
                          value={row.retailPrice}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "+" ||
                              e.key === "e"
                            ) {
                              e.preventDefault(); // Prevent negative, plus, or exponential notation input
                            }
                          }}
                          onChange={(e) =>
                            handleChange(index, "retailPrice", e.target.value)
                          }
                        />
                      </Col>
                      <Col md={3} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Commission"
                          value={
                            row.retailPrice
                              ? (
                                  row.retailPrice -
                                  row.retailPrice * 0.99
                                ).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleChange(index, "commission", e.target.value)
                          }
                          disabled
                        />
                      </Col>
                      <Col md={3} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Your share"
                          value={
                            row.retailPrice
                              ? (row.retailPrice * 0.99).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleChange(index, "yourShare", e.target.value)
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                  ))}
                  {formError && <div className="text-danger">{formError}</div>}
                </div>
                <Form.Group
                  controlId="tieredPricing"
                  className="cp-ps-time-switch-container"
                >
                  <FormCheck
                    type="switch"
                    id="enable-tiered-pricing"
                    label="Live availability"
                    checked={liveAvailability}
                    onChange={() => {
                      setLiveAvailability(!liveAvailability);
                    }}
                  />
                </Form.Group>
                {liveAvailability && (
                  <>
                    {" "}
                    <Form.Group controlId="">
                      <Form.Label className="cp-ps-form-label">
                        Select the days these prices apply
                      </Form.Label>
                      <div className="cp-pc-attraction-modal-input-checkbox d-flex align-items-center cp-ps-radio-input border-0 h-0">
                        <Form.Check
                          type="checkbox"
                          name={"options"}
                          // value={value}
                          checked={selectedDays}
                          onChange={() => {
                            setSelectedDays(!selectedDays);
                            if (!selectedDays) {
                              handleSelectAllDays(values, setFieldValue);
                            } else {
                              handleDeselectAllDays(values, setFieldValue);
                            }
                            // setFieldValue("daysApply", selectedDays);
                          }}
                          className={"radio-button mt-0 mb-0 cp-ps-radio"}
                        />
                        <p className=" m-0 p-0 ">Select All</p>
                      </div>

                      <div className="d-flex flex-column cp-ps-step-2-days-checkboxes-wrapper">
                        <div className="cp-ps-step-2-days-checkboxes">
                          {weeklyData?.data?.map((day) => (
                            <div
                              key={day.day_id}
                              name
                              className={`cp-ps-day-check-box ${
                                values?.daysApply?.includes(day?.day_id)
                                  ? "cp-ps-day-selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleDayClick(
                                  day.day_id,
                                  values,
                                  setFieldValue
                                )
                              }
                            >
                              {day?.day_name}
                            </div>
                          ))}
                        </div>
                        <ErrorMessage
                          name="daysApply"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="timeApply">
                      <Form.Label className="cp-ps-form-label">
                        Select the time these prices apply{" "}
                        <span>(optional)</span>
                      </Form.Label>
                      {timeSlots?.map((slot, index) => {
                        // Get selected start times from all slots except the current one
                        const selectedTimes = timeSlots
                          .filter((s) => s.id !== slot.id)
                          .map((s) => s.start_time);

                        // Filter the available time options for the current slot
                        const availableTimeOptions = timeOptions.filter(
                          (option) => !selectedTimes.includes(option.value)
                        );

                        return (
                          <InputGroup
                            className="cp-ps-timeslot-main mb-3 d-flex align-items-center"
                            key={slot.id}
                          >
                            {/* Start Time Select */}
                            <Select
                              name={`startTime-${slot.id}`}
                              options={availableTimeOptions}
                              placeholder="Select start time"
                              className="p-0 form-control cp-ps-timeslot-select ms-0"
                              value={availableTimeOptions.find(
                                (option) => option.value === slot.start_time
                              )}
                              onChange={(selectedOption) =>
                                handleStartTimeChange(slot.id, selectedOption)
                              }
                              components={{
                                Control: ({ children, ...props }) => (
                                  <components.Control {...props}>
                                    {children}
                                    <div className="select-icon">
                                      <Icon icon="ic:baseline-keyboard-arrow-down" />
                                    </div>
                                  </components.Control>
                                ),
                              }}
                            />

                            {/* Delete Icon */}
                            <img
                              src={DeleteIcon}
                              alt="delete-icon"
                              className="ms-2"
                              onClick={() => handleRemoveTimeSlot(slot.id)} // Use id to remove the correct slot
                              style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
                            />
                          </InputGroup>
                        );
                      })}
                      <p onClick={addTimeSlot} className="add-time-slot">
                        + Add a time slot
                      </p>
                      {timeError && (
                        <div className="text-danger mb-2">{timeError}</div>
                      )}
                    </Form.Group>
                  </>
                )}
                <div
                  className={`w-100 d-flex align-items-center ${
                    !productOptionId
                      ? "justify-content-between"
                      : "justify-content-end"
                  }`}
                >
                  {!productOptionId && (
                    <button className="back-btn" onClick={() => setStep(1)}>
                      Back
                    </button>
                  )}
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isLoading}
                    // onClick={() => {
                    //   setData((prevData) => [...prevData, 1]);
                    //   handleClose();
                    // }}
                  >
                    Save {isLoading && <Spinner size="sm" />}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </>
      )}
    </Formik>
  );
};

export default PSstepThree;
